
import { computed, defineComponent, PropType } from 'vue'
import { MemberProfile } from '@/modules/members'
import MembersUpdateSupervisor from '@/components/members/update/supervisor.vue'
import MembersUpdateHierarchyAssignment from '@/components/members/update/hierarchy-assignment.vue'
import MembersUpdateReporting from '@/components/members/update/reporting.vue'
import MembersUpdatePhone from '@/components/members/update/phone.vue'
import MembersUpdateRole from '@/components/members/update/role.vue'
import { useOrganizationModule } from '@/modules/organizations'
import { useRoute } from 'vue-router'

export default defineComponent({
    name: 'members-show-member-organization-info',
    components: {
        MembersUpdateSupervisor,
        MembersUpdateHierarchyAssignment,
        MembersUpdateReporting,
        MembersUpdatePhone,
        MembersUpdateRole
    },
    props: {
        member: {
            type: Object as PropType<MemberProfile>,
            required: true
        }
    },
    async setup (props) {
        const route = useRoute()
        const { getMemberOrganizationProfile } = useOrganizationModule()

        const memberWithOrganization = await getMemberOrganizationProfile(props.member.organizationId as string, route.params.memberId as string)

        const memberOrganizationInfoModel = computed<MemberProfile>(() => {
            return {
                ...props.member,
                supervisor: memberWithOrganization.supervisor,
                hierarchyAssignment: memberWithOrganization.hierarchyAssignment,
                reporting: memberWithOrganization.reporting,
                phone: memberWithOrganization.phone,
                accessGranted: memberWithOrganization.accessGranted,
                accessRevoked: memberWithOrganization.accessRevoked,
                permissions: memberWithOrganization.permissions
            }
        })

        return {
            memberOrganizationInfoModel
        }
    }
})
